/** Service Desk console: Service settings, General tab - modules, customer mode and template packs (SD-S1-67 / 68 / 69). */
export const serviceSettings = {
  modules: {
    title: "Service modules",
    intro: "Switch on only what your team uses. A module that is off disappears from the menu, its pages answer \"not found\", and its defaults pause; nothing is deleted.",
    alwaysOn: "Always on",
    hiddenInB2c: "Hidden for individual customers",
    switchedOn: "{{module}} is on.",
    switchedOff: "{{module}} is off. Its data is kept.",
    tickets: { title: "Tickets", hint: "Requests, replies, SLA clocks and CSAT. Every workspace has it." },
    organisations: { title: "Organisations", hint: "Client companies, their contacts, roles and shared visibility, for business customers." },
    assets: { title: "Assets", hint: "Installed equipment with serial numbers, warranty and service history." },
    projects: { title: "Projects / installations", hint: "Staged installations with open items, sign-off and handover." },
    visits: { title: "Field visits", hint: "Scheduled engineer visits with checklists and reports." },
    orders: { title: "Orders & catalogue", hint: "Product catalogue and client orders through your order system." },
  },
  mode: {
    title: "Who are your customers?",
    intro: "This decides whether organisations exist. Tickets and contacts work in every mode, and switching back keeps every ticket.",
    saved: "Customer mode saved.",
    b2b: { label: "Businesses", hint: "Companies with contacts: organisation screens, roles, colleagues and shared tickets." },
    b2c: { label: "Individuals", hint: "Each ticket belongs to a person. Organisation screens, roles, colleagues and shared visibility are hidden." },
    mixed: { label: "Both", hint: "Companies and individual customers live side by side." },
  },
  packs: {
    title: "Industry template pack",
    intro: "A pack gives your desk the words, ticket types, fields, macros and sample SLAs of an industry. It only adds: nothing you edited is overwritten or deleted, and you can apply another pack later.",
    suggested: "Suggested",
    current: "In use",
    additive: "Applying a pack again only adds what is missing.",
    notApplied: "No pack applied yet. Generic words and the built-in ticket types are in use.",
    preview: "Preview and apply",
    previewTitle: "Apply the {{name}} pack",
    previewHint: "This is what will change. Nothing is written until you apply.",
    previewRegion: "What will change",
    previewError: "Couldn't preview this pack",
    cancel: "Cancel",
    apply: "Apply pack",
    applied: "{{name}} applied: {{added}} added, {{updated}} updated.",
    nothingToAdd: "Everything in this pack is already in place. Nothing to add.",
    suggestions: "Also in this pack, offered when their screens open: {{parts}}.",
    change: { add: "Add", update: "Update", keep: "Kept", plan_limit: "Not on your plan" },
    part: {
      modules: "Modules",
      customer_mode: "Customer mode",
      vocabulary: "Words used in the console and portal",
      ticket_types: "Ticket types",
      type_labels: "Built-in types relabelled",
      fields: "Fields",
      type_fields: "Fields on types",
      status_labels: "Status labels clients see",
      resolution_codes: "Resolution codes",
      macros: "Macros",
      csat_reasons: "CSAT reasons",
      calendars: "Business calendars",
      sla_policies: "SLA policies",
    },
    suggestion: {
      home_options: "widget Home options",
      stage_templates: "project stage templates",
      visit_checklists: "visit checklists",
      asset_categories: "asset categories",
      connector_operations: "connector operations",
    },
  },
} as const;
